module.exports = __webpack_public_path__ + "static/img/ylt.d1b8942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/ylt.jpg
// module id = Artb
// module chunks = 1